const endpoints = {
  spotify: '/.netlify/functions/spotify',
  contact: '/.netlify/functions/contact',
};

export default endpoints;
